
export const environment = {
  production: false,
  apiUrl: 'https://gemeo-plataforma-dev-api.enacloud.me',
  urlFront: 'https://gemeo-plataforma-dev.enacloud.me',
  redirectUri: 'https://gemeo-plataforma-dev.enacloud.me',
  //redirectUri: 'http://localhost:5555',
  //urlFront: 'http://localhost:5555',


  apiUrlBuffer: '',
  token: '',
  client: '8d5b2063-6ae3-49f7-b9a4-df7a3dc92e17',
  authority: 'https://login.microsoftonline.com/efa10a2e-43c9-4e1e-8b6f-e1dd91403848',
};